import { z } from "zod";

export const DeleteRolesSchema = z.object({
    id: z.number().int().positive()
});

export type DeleteRolesFormData = z.infer<typeof DeleteRolesSchema>;